import { render, staticRenderFns } from "./EditEvents.vue?vue&type=template&id=12888066&scoped=true&"
import script from "./EditEvents.vue?vue&type=script&lang=js&"
export * from "./EditEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12888066",
  null
  
)

export default component.exports